import type { NameParts } from './getNameParts.types';

/**
 * Splits a full display name into firstName and lastName parts.
 * Useful for deriving CobaltAvatar initials from a single name string.
 *
 * @param fullName - A display name (e.g., "CAE Aviation" or "John")
 * @returns An object with firstName (first word) and lastName (second word, if any)
 */
export function getNameParts(fullName: string): NameParts {
  const parts = fullName.trim().split(/\s+/);
  return {
    firstName: parts[0] || '',
    lastName: parts[1],
  };
}
